import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {SchedaClientiComponent} from './scheda-clienti';
import { ModificaClienteModule } from './modifica-cliente/modifica-cliente.module';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.scheda-clienti', {
            url: '/scheda-clienti',
            ncyBreadcrumb: {
                label: 'scheda-clienti',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'scheda-clienti'
            },
            'views': {
                'homeContent': {
                    template: '<scheda-clienti flex="100"></scheda-clienti>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const SchedaClientiModule: string = ng
    .module('scheda-clienti', [
        'ui.bootstrap',
        uiRouter,
        ModificaClienteModule
    ])
    .component('schedaClienti', SchedaClientiComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/scheda-clienti/scheda-clienti.module.ts